import _regeneratorRuntime from "@babel/runtime/regenerator";
var _jsxFileName = "/builds/ccm-innovation/ccm-2.0/address-components/src/components/AddressPicker/AddressPicker.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import Lodash from 'lodash';
import Path from 'path';
import Autosuggest from 'react-autosuggest';
import * as AddressAPI from '../../utils/address-api';
import * as Utils from '../../utils/ccm-address-utils';
import SuggestedAddressModal from './SuggestedAddressModal';
import SubPremiseModal from './SubPremiseModal';
import StatePicker from '../StatePicker';
import './AddressPicker.css';
var warningIcon = Path.resolve('./assets/img/warning-icon.png');

var getSuggestionValue = function getSuggestionValue(suggestion) {
  return suggestion.value;
};

function renderSuggestion(suggestion) {
  return /*#__PURE__*/React.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 5
    }
  }, suggestion.label);
}

var AddressPicker = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AddressPicker, _Component);

  function AddressPicker(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      suggestions: [],
      subPremises: [],
      address: {
        line1: '',
        city: '',
        state: null,
        zip: '',
        latitude: null,
        longitude: null,
        addressVerified: false
      },
      subPremisePresent: false,
      validationMessage: null,
      isValidating: false,
      addressIsValidated: null,
      showSuggestedAddressModal: false,
      showSubPremiseModal: false,
      lastFetchValue: null
    };
    _this.config = {
      auth: {
        username: _this.props.muleClientId,
        password: _this.props.muleClientSecret
      },
      headers: {
        "access-control-allow-origin": "*"
      }
    };
    _this.onSuggestionsFetchRequested = Lodash.debounce(function (_ref) {
      var value = _ref.value;
      var searchResults = [];
      var filteredInput = Utils.filterAddressField(value);
      var _this$state = _this.state,
          subPremisePresent = _this$state.subPremisePresent,
          lastFetchValue = _this$state.lastFetchValue;

      if (!subPremisePresent && Utils.isQualifiedAutosuggestSearch(filteredInput, lastFetchValue)) {
        var trimmedLine1 = _this.getAddressFromState().line1.trim();

        var paramsObj = {
          line1: trimmedLine1
        };
        AddressAPI.getAutocompleteSuggestions(_this.config, _this.props.muleApiUrl, Utils.buildAddressQueryParams(paramsObj, 10), function (response) {
          response.data.forEach(function (address) {
            searchResults.push({
              label: address.line1 + " " + address.city + ", " + address.state + " " + address.zip,
              value: address
            });
          });

          _this.setState({
            suggestions: searchResults,
            lastFetchValue: trimmedLine1
          });
        }, function (error) {
          _this.setState({
            isValidating: false
          });

          _this.handleError(error);
        });
      }
    }, 500);

    _this.onSuggestionsClearRequested = function () {};

    return _this;
  }

  var _proto = AddressPicker.prototype;

  _proto.componentWillMount = /*#__PURE__*/function () {
    var _componentWillMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this2 = this;

      var addressProp;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              addressProp = this.props.address; // If address prop has been passed to component, confirm it's not null

              if (addressProp) {
                // If not null, set the fields that you can
                this.setState({
                  address: {
                    line1: addressProp.line1 ? addressProp.line1 : '',
                    city: addressProp.city ? addressProp.city : '',
                    state: addressProp.state ? addressProp.state : null,
                    zip: addressProp.zip ? addressProp.zip : '',
                    latitude: addressProp.latitude ? addressProp.latitude : null,
                    longitude: addressProp.longitude ? addressProp.longitude : null,
                    addressVerified: false
                  }
                }, function () {
                  // Check for verification if prop flag to do so is set to true
                  if (_this2.props.checkForValidAddressUponMount) {
                    // Get address from state
                    var address = _this2.state.address; // If all 4 fields are populated to some extend, manually verify address with endpoint

                    if (address.line1 !== '' && address.city !== '' && address.state !== null && address.zip !== '') {
                      AddressAPI.requestAddressVerification(_this2.config, _this2.props.muleApiUrl, Utils.buildAddressQueryParams(address), function (response) {
                        var data = response.data;

                        if (data.valid) {
                          var populatedAddress = {
                            line1: data.line1,
                            city: data.city,
                            state: data.state,
                            zip: data.zip,
                            latitude: null,
                            longitude: null,
                            addressVerified: true
                          }; // If toggle prop calls to fetch Gecode data, include it in address

                          if (_this2.props.includeGeocodeData) populatedAddress = Object.assign(populatedAddress, {
                            latitude: data.latitude,
                            longitude: data.longitude
                          });

                          _this2.setState({
                            address: populatedAddress,
                            addressIsValidated: true
                          }, function () {
                            _this2.setTemporaryMessage('Address Validated');

                            _this2.props.onAddressCollected(_this2.getAddressFromState());
                          });
                        } else {
                          _this2.setState({
                            address: address,
                            addressIsValidated: false,
                            subPremisePresent: false
                          }, function () {
                            _this2.setTemporaryMessage('Please Enter Valid Address', 1000);

                            _this2.props.onAddressInvalidated();
                          });
                        }
                      }, function (error) {
                        _this2.setState({
                          isValidating: false
                        });

                        _this2.handleError(error);
                      });
                    } else {
                      _this2.setState({
                        addressIsValidated: false,
                        subPremisePresent: false
                      }, function () {
                        return _this2.setTemporaryMessage('Please Enter Valid Address', 1000);
                      });
                    }
                  }
                });
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentWillMount() {
      return _componentWillMount.apply(this, arguments);
    }

    return componentWillMount;
  }();

  _proto.getAddressFromState = function getAddressFromState() {
    return this.state.address;
  };

  _proto.setTemporaryMessage = function setTemporaryMessage(message, duration) {
    var _this3 = this;

    this.setState({
      validationMessage: message
    }, function () {
      return setTimeout(function () {
        _this3.setState({
          validationMessage: null
        });
      }, duration || 1000);
    });
  };

  _proto.setPermanentMessage = function setPermanentMessage(message) {
    this.setState({
      validationMessage: message
    });
  };

  _proto.handleManuallyEnteredAddressVerified = function handleManuallyEnteredAddressVerified(data) {
    var _this4 = this;

    var validAddress = {
      line1: data.line1,
      city: data.city,
      state: data.state,
      zip: data.zip,
      latitude: this.props.includeGeocodeData ? data.latitude : null,
      longitude: this.props.includeGeocodeData ? data.longitude : null,
      addressVerified: true
    }; // If toggle prop calls to fetch Gecode data, include it in address

    if (this.props.includeGeocodeData) validAddress = Object.assign(validAddress, {
      latitude: data.latitude,
      longitude: data.longitude
    });
    this.setState({
      address: validAddress,
      isValidating: false,
      addressIsValidated: true,
      validationMessage: null,
      showSuggestedAddressModal: false
    }, function () {
      _this4.props.onAddressCollected(_this4.getAddressFromState());
    });
  };

  _proto.getGeocodingAndStoreInState = function getGeocodingAndStoreInState(queryParams, callback) {
    var _this5 = this;

    AddressAPI.requestAddressVerification(this.config, this.props.muleApiUrl, queryParams, function (response) {
      var data = response.data;

      var currentAddressInState = _this5.getAddressFromState();

      _this5.setState({
        address: _extends(_extends({}, currentAddressInState), {}, {
          latitude: data.valid ? data.latitude : null,
          longitude: data.valid ? data.longitude : null
        })
      }, callback);
    }, function (error) {
      _this5.setState({
        isValidating: false
      });

      _this5.handleError(error);
    });
  };

  _proto.handleManuallyEnteredAddressNotVerified = function handleManuallyEnteredAddressNotVerified(queryParams) {
    var _this6 = this;

    // ensure consumer of this component knows that address was attempted to be verified and failed
    this.handleAddressInvalidated(true);
    AddressAPI.getAutocompleteSuggestions(this.config, this.props.muleApiUrl, queryParams, function (suggestions) {
      var searchResults = [];
      suggestions.data.forEach(function (suggestedAddress) {
        searchResults.push({
          label: suggestedAddress.line1 + " " + suggestedAddress.city + ", " + suggestedAddress.state + " " + suggestedAddress.zip,
          value: suggestedAddress
        });
      });

      _this6.setState({
        suggestions: searchResults,
        isValidating: true,
        validationMessage: null,
        showSuggestedAddressModal: true
      });
    }, function (error) {
      var showSuggestedAddressModal = true;

      _this6.setState({
        isValidating: false
      });

      _this6.handleError(error, showSuggestedAddressModal);
    });
  };

  _proto.handleBlur = function handleBlur() {
    var _this7 = this;

    var _this$state2 = this.state,
        address = _this$state2.address,
        addressIsValidated = _this$state2.addressIsValidated;
    var line1 = address.line1,
        city = address.city,
        state = address.state,
        zip = address.zip;

    if (line1 && city && state && zip) {
      if (!addressIsValidated && Utils.checkIfAddressIsReadyForVerification(address)) {
        // If manually entered address has not yet been validated then check to see that it's valid
        this.setState({
          isValidating: true,
          validationMessage: 'Verifying address'
        });
        AddressAPI.requestAddressVerification(this.config, this.props.muleApiUrl, Utils.buildAddressQueryParams(address), function (response) {
          var data = response.data;

          if (data.valid) {
            _this7.handleManuallyEnteredAddressVerified(data);
          } else {
            // Manually entered address is not considered valid by Melissa Data
            _this7.handleManuallyEnteredAddressNotVerified(Utils.buildAddressQueryParams(address, 5));
          }
        }, function (error) {
          _this7.setState({
            isValidating: false
          });

          _this7.handleError(error);
        });
      }
    }
  };

  _proto.handleInputChange = function handleInputChange(event, _ref2) {
    var _this8 = this;

    var newValue = _ref2.newValue,
        method = _ref2.method;

    switch (method) {
      case 'type':
        {
          var _this$getAddressFromS = this.getAddressFromState(),
              city = _this$getAddressFromS.city,
              state = _this$getAddressFromS.state,
              zip = _this$getAddressFromS.zip;

          this.setState({
            address: {
              line1: Utils.filterAddressField(newValue),
              city: city,
              state: state,
              zip: zip,
              latitude: null,
              longitude: null
            },
            validationMessage: null,
            subPremisePresent: false,
            suggestions: []
          }, function () {
            return _this8.handleAddressInvalidated();
          });
          break;
        }

      case 'click':
      case 'enter':
        {
          var line1 = newValue.line1,
              _city = newValue.city,
              _state = newValue.state,
              _zip = newValue.zip;
          var address = {
            line1: line1,
            city: _city,
            state: _state,
            zip: _zip,
            latitude: null,
            longitude: null,
            addressVerified: true
          };

          if (newValue.suiteList) {
            address.addressVerified = false;
            this.setState({
              address: address,
              addressIsValidated: false,
              subPremisePresent: false,
              isValidating: true,
              subPremises: newValue.suiteList
            }, function () {
              return _this8.setState({
                showSubPremiseModal: true
              });
            });
          } else {
            this.setState({
              address: address,
              addressIsValidated: true,
              suggestions: []
            }, function () {
              if (_this8.props.includeGeocodeData) {
                // Fetch Geocode values and store in state
                _this8.getGeocodingAndStoreInState(Utils.buildAddressQueryParams(newValue), function () {
                  _this8.props.onAddressCollected(_this8.getAddressFromState());
                });
              } else {
                _this8.props.onAddressCollected(address);
              }
            });
          }

          break;
        }

      default:
        {
          break;
        }
    }
  };

  _proto.handleAddressInvalidated = function handleAddressInvalidated(forcePropCall) {
    var addressCurrentlyInState = this.getAddressFromState();

    if (this.state.addressIsValidated || forcePropCall) {
      this.setState({
        address: _extends(_extends({}, addressCurrentlyInState), {}, {
          longitude: null,
          latitude: null
        }),
        addressIsValidated: false
      }, this.props.onAddressInvalidated());
    }
  };

  _proto.closeSuggestedAddressModal = function closeSuggestedAddressModal() {
    var _this9 = this;

    this.setState({
      showSuggestedAddressModal: false,
      showSubPremiseModal: false,
      subPremises: [],
      lastFetchValue: null,
      isValidating: false
    }, function () {
      return _this9.props.onAddressInvalidated();
    });
  };

  _proto.closeSubPremiseModal = function closeSubPremiseModal() {
    var _this10 = this;

    this.setState({
      showSubPremiseModal: false,
      subPremises: [],
      lastFetchValue: null,
      isValidating: false
    }, function () {
      return _this10.props.onAddressInvalidated();
    });
  };

  _proto.handleAddressSelected = function handleAddressSelected(selectedAddress) {
    var _this11 = this;

    var line1 = selectedAddress.line1,
        city = selectedAddress.city,
        state = selectedAddress.state,
        zip = selectedAddress.zip,
        addressVerified = selectedAddress.addressVerified;
    var needToGatherSubPremise = !!selectedAddress.suiteList;
    this.setState({
      address: {
        line1: line1,
        city: city,
        state: state,
        zip: zip,
        latitude: null,
        longitude: null,
        addressVerified: addressVerified
      },
      suggestions: [],
      subPremises: selectedAddress.suiteList,
      showSubPremiseModal: needToGatherSubPremise,
      isValidating: needToGatherSubPremise,
      addressIsValidated: !needToGatherSubPremise,
      showSuggestedAddressModal: false,
      lastFetchValue: null
    }, function () {
      if (_this11.props.includeGeocodeData && addressVerified) {
        // Fetch Geocode values and store in state
        _this11.getGeocodingAndStoreInState(Utils.buildAddressQueryParams(selectedAddress), function () {
          _this11.setTemporaryMessage('Address Validated');

          _this11.props.onAddressCollected(_this11.getAddressFromState());
        });
      } else {
        _this11.setTemporaryMessage('Address Validated');

        _this11.props.onAddressCollected(_this11.getAddressFromState());
      }
    });
  };

  _proto.handleSubPremiseSelected = function handleSubPremiseSelected(subPremise) {
    var _this12 = this;

    var addressInState = this.getAddressFromState();
    this.setState({
      isValidating: false,
      addressIsValidated: true,
      suggestions: [],
      subPremises: [],
      address: _extends(_extends({}, addressInState), {}, {
        line1: addressInState.line1 + " " + subPremise,
        addressVerified: true
      }),
      subPremisePresent: true,
      showSubPremiseModal: false
    }, function () {
      if (_this12.props.includeGeocodeData) {
        // Fetch Geocode values and store in state
        _this12.getGeocodingAndStoreInState(Utils.buildAddressQueryParams(_this12.getAddressFromState()), function () {
          _this12.props.onAddressCollected(_this12.getAddressFromState());
        });
      } else {
        _this12.props.onAddressCollected(_this12.getAddressFromState());
      }
    });
  };

  _proto.handleUpdateState = function handleUpdateState(state) {
    var _this13 = this;

    var address = this.state.address;
    this.setState({
      address: _extends(_extends({}, address), {}, {
        state: state
      }),
      validationMessage: null
    }, function () {
      return _this13.handleAddressInvalidated();
    });
  };

  _proto.handleError = function handleError(error, showSuggestionModal) {
    var errorMessage = error.response.data.error.errorMessage;

    if (showSuggestionModal) {
      this.setState({
        showSuggestedAddressModal: true
      });
    } else {
      if (errorMessage === 'no results found') {
        this.setTemporaryMessage('No results found; please be more specific with your search.', 2500);
      } else {
        this.setTemporaryMessage("ERROR: " + errorMessage, 2500);
      }
    }
  };

  _proto.buildLine1Theme = function buildLine1Theme(style) {
    var mainWidth = style.mainWidth,
        borderRadius = style.borderRadius,
        generalInputStyle = style.generalInputStyle,
        line1InputStyle = style.line1InputStyle;
    return {
      container: 'line1-container',
      containerOpen: 'line1-container--open',
      input: "line1-input-field " + (borderRadius || 'border-radius') + " " + (generalInputStyle || '') + " " + (line1InputStyle || ''),
      inputOpen: 'line1-input--open',
      inputFocused: 'line1-input--focused',
      suggestionsContainer: "line1-suggestions-container " + (mainWidth || 'main-width'),
      suggestionsContainerOpen: 'line1-suggestions-container--open',
      suggestionsList: 'line1-suggestions-list',
      suggestion: 'line1-suggestion',
      suggestionFirst: 'line1-suggestion--first',
      suggestionHighlighted: 'line1-suggestion--highlighted',
      sectionContainer: 'line1-section-container',
      sectionContainerFirst: 'line1-section-container--first',
      sectionTitle: 'line1-section-title'
    };
  };

  _proto.buildSuggestionModalTheme = function buildSuggestionModalTheme(style) {
    var modalWidth = style.modalWidth;
    return {
      modalWidth: modalWidth || 'modal-width'
    };
  };

  _proto.buildSubPremiseModalTheme = function buildSubPremiseModalTheme(style) {
    var modalWidth = style.modalWidth;
    return {
      modalWidth: modalWidth || 'modal-width'
    };
  };

  _proto.renderAsterisk = function renderAsterisk(showRequiredAsterisks) {
    if (showRequiredAsterisks) {
      return /*#__PURE__*/React.createElement("span", {
        className: this.props.style.requiredAsterisk || 'required-asterisk',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 542,
          columnNumber: 14
        }
      }, "*");
    }
  };

  _proto.render = function render() {
    var _this14 = this;

    var _this$state3 = this.state,
        address = _this$state3.address,
        suggestions = _this$state3.suggestions,
        subPremises = _this$state3.subPremises,
        isValidating = _this$state3.isValidating,
        showSuggestedAddressModal = _this$state3.showSuggestedAddressModal,
        showSubPremiseModal = _this$state3.showSubPremiseModal,
        validationMessage = _this$state3.validationMessage;
    var _this$props = this.props,
        componentDisabled = _this$props.componentDisabled,
        muleApiUrl = _this$props.muleApiUrl,
        muleClientId = _this$props.muleClientId,
        muleClientSecret = _this$props.muleClientSecret,
        title = _this$props.title,
        style = _this$props.style,
        showProcessingMessages = _this$props.showProcessingMessages,
        showRequiredAsterisks = _this$props.showRequiredAsterisks,
        statesOverride = _this$props.statesOverride,
        onStatesFetched = _this$props.onStatesFetched;
    var searchInput = address.line1;
    var inputProps = {
      value: searchInput,
      onChange: function onChange(event, payload) {
        return _this14.handleInputChange(event, payload);
      },
      disabled: isValidating || componentDisabled,
      onBlur: function onBlur() {
        return _this14.handleBlur();
      },
      autoComplete: 'none',
      name: 'street-address'
    };
    var line1Theme = this.buildLine1Theme(style);
    var suggestionModalTheme = this.buildSuggestionModalTheme(style);
    var subPremiseModalTheme = this.buildSubPremiseModalTheme(style);
    var mainWidth = style.mainWidth,
        borderRadius = style.borderRadius,
        requiredAsterisk = style.requiredAsterisk,
        generalInputStyle = style.generalInputStyle,
        cityInputStyle = style.cityInputStyle,
        stateInputStyle = style.stateInputStyle,
        zipInputStyle = style.zipInputStyle;
    return /*#__PURE__*/React.createElement("div", {
      className: "container-wrapper " + (mainWidth || 'main-width'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 595,
        columnNumber: 7
      }
    }, title && /*#__PURE__*/React.createElement("p", {
      className: 'header',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 598,
        columnNumber: 11
      }
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "form-fields",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 600,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "ccm-address-row",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 601,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-element width--1-of-1",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 602,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("label", {
      className: 'line1-field-label',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 605,
        columnNumber: 15
      }
    }, "Street Address", this.renderAsterisk(showRequiredAsterisks)), /*#__PURE__*/React.createElement(Autosuggest, {
      autocomplete: 'none',
      theme: line1Theme,
      inputProps: inputProps,
      suggestions: suggestions,
      onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.onSuggestionsClearRequested,
      getSuggestionValue: getSuggestionValue,
      renderSuggestion: renderSuggestion,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 606,
        columnNumber: 15
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ccm-address-row",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 619,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-element width--2-of-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 620,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("label", {
      className: 'city-field-label',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 623,
        columnNumber: 15
      }
    }, "City", this.renderAsterisk(showRequiredAsterisks)), /*#__PURE__*/React.createElement("input", {
      type: "text",
      name: 'city',
      autoComplete: 'none',
      className: "city-input-field " + (borderRadius || 'border-radius') + " " + (generalInputStyle || '') + " " + (cityInputStyle || ''),
      disabled: isValidating || componentDisabled,
      value: address.city,
      onChange: function onChange(event) {
        return _this14.setState({
          address: _extends(_extends({}, address), {}, {
            city: event.target.value
          }),
          validationMessage: null
        }, function () {
          return _this14.handleAddressInvalidated();
        });
      },
      onBlur: function onBlur() {
        return _this14.handleBlur();
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 624,
        columnNumber: 15
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "form-element width--1-of-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 641,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(StatePicker, {
      selectedState: address.state,
      onStateSelected: function onStateSelected(state) {
        return _this14.handleUpdateState(state);
      },
      onBlur: function onBlur() {
        return _this14.handleBlur();
      },
      muleApiUrl: muleApiUrl,
      muleClientId: muleClientId,
      muleClientSecret: muleClientSecret,
      statesOverride: statesOverride,
      onStatesFetched: onStatesFetched,
      showRequiredAsterisk: showRequiredAsterisks,
      disabled: isValidating || componentDisabled,
      style: {
        borderRadius: borderRadius,
        generalInputStyle: generalInputStyle,
        requiredAsterisk: requiredAsterisk,
        stateInputStyle: "state-input-field " + stateInputStyle,
        titleStyle: 'state-field-label'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 644,
        columnNumber: 15
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "form-element width--1-of-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 664,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("label", {
      className: 'zip-field-label',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 667,
        columnNumber: 15
      }
    }, "Zip", this.renderAsterisk(showRequiredAsterisks)), /*#__PURE__*/React.createElement("input", {
      type: "text",
      name: 'zip',
      autoComplete: 'none',
      className: "zip-input-field " + (borderRadius || 'border-radius') + " " + (generalInputStyle || '') + " " + (zipInputStyle || ''),
      maxLength: "10",
      disabled: isValidating || componentDisabled,
      value: address.zip,
      onChange: function onChange(event) {
        return _this14.setState({
          address: _extends(_extends({}, address), {}, {
            zip: Utils.filterZipField(event.target.value)
          }),
          validationMessage: null
        }, function () {
          return _this14.handleAddressInvalidated();
        });
      },
      onBlur: function onBlur() {
        return _this14.handleBlur();
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 668,
        columnNumber: 15
      }
    }))), validationMessage && showProcessingMessages && /*#__PURE__*/React.createElement("div", {
      className: "slds-form-element__row",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 690,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "slds-form-element slds-size--1-of-1",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 691,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: 'address-picker-validation-message',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 694,
        columnNumber: 17
      }
    }, validationMessage))), showSuggestedAddressModal && /*#__PURE__*/React.createElement(SuggestedAddressModal, {
      style: suggestionModalTheme,
      isOpen: showSuggestedAddressModal,
      warningIcon: warningIcon,
      enteredAddress: address,
      suggestedAddresses: suggestions,
      handleAddressSelected: function handleAddressSelected(selectedAddress) {
        return _this14.handleAddressSelected(selectedAddress);
      },
      closeModal: function closeModal() {
        return _this14.closeSuggestedAddressModal();
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 700,
        columnNumber: 13
      }
    }), showSubPremiseModal && /*#__PURE__*/React.createElement(SubPremiseModal, {
      style: subPremiseModalTheme,
      isOpen: showSubPremiseModal,
      subPremises: subPremises,
      handleSubPremiseSelected: function handleSubPremiseSelected(subPremise) {
        return _this14.handleSubPremiseSelected(subPremise);
      },
      closeModal: function closeModal() {
        return _this14.closeSubPremiseModal();
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 712,
        columnNumber: 13
      }
    })));
  };

  return AddressPicker;
}(Component);

export { AddressPicker as default };
AddressPicker.defaultProps = {
  showProcessingMessages: false,
  showRequiredAsterisks: false,
  checkForValidAddressUponMount: false,
  componentDisabled: false,
  includeGeocodeData: false,
  statesOverride: null,
  style: {
    borderRadius: 'border-radius',
    mainWidth: 'main-width',
    modalWidth: 'modal-width',
    generalInputStyle: '',
    // No default class for invalid border
    line1InputStyle: '',
    cityInputStyle: '',
    stateInputStyle: 'state-input-field',
    zipInputStyle: ''
  }
};
AddressPicker.propTypes = process.env.NODE_ENV !== "production" ? {
  address: PropTypes.object,
  checkForValidAddressUponMount: PropTypes.bool,
  muleApiUrl: PropTypes.string.isRequired,
  muleClientId: PropTypes.string.isRequired,
  muleClientSecret: PropTypes.string.isRequired,
  componentDisabled: PropTypes.bool,
  includeGeocodeData: PropTypes.bool,
  onAddressInvalidated: PropTypes.func.isRequired,
  onAddressCollected: PropTypes.func.isRequired,
  onStatesFetched: PropTypes.func,
  showProcessingMessages: PropTypes.bool,
  showRequiredAsterisks: PropTypes.bool,
  statesOverride: PropTypes.array,
  style: PropTypes.object,
  title: PropTypes.string
} : {};